import React from "react";
import PropTypes from "prop-types";

import { Field, Control } from "rbx";
import { SystemCodeSelect } from "../inputs";

const LocationTypeForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field>
      <Control>
        <SystemCodeSelect
          icon="compass"
          label="Location Type"
          lookup={{ Category: "Location", Code: "LocType" }}
          name="LocationTypeRecIdRef"
          value={inputs.LocationTypeRecIdRef}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

LocationTypeForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

export default LocationTypeForm;
